import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Spinner from "../../Components/Common/Spinner";
import AxiosInstance from "../../services/AxiosInstance";

/** Stored after a valid public campaign link is opened; registration sends this secret to the API (not numeric id). */
export const PENDING_RECRUITER_CAMPAIGN_PUBLIC_TOKEN_KEY =
  "naukrify_pending_campaign_public_token";

const normalizeToken = (raw) =>
  String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-f0-9]/g, "");

/**
 * Public entry: shared campaign link (opaque token). Validates token with API, then recruiter registration.
 */
const RecruiterCampaignInviteLanding = () => {
  const { campaignPublicToken } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const normalized = normalizeToken(campaignPublicToken);
    if (normalized.length < 32 || normalized.length > 64) {
      setError("This invitation link is not valid.");
      return;
    }

    (async () => {
      try {
        const res = await AxiosInstance().get(
          `invitation_campaign/validate_public_token/${normalized}`
        );
        if (cancelled) return;
        if (!res.data?.status) {
          setError("This invitation link is not valid or has expired.");
          return;
        }
        try {
          localStorage.setItem(
            PENDING_RECRUITER_CAMPAIGN_PUBLIC_TOKEN_KEY,
            normalized
          );
        } catch (e) {
          /* ignore */
        }
        const base = (process.env.PUBLIC_URL || "/job").replace(/\/$/, "");
        navigate(`${base}/recruiter/auth/register`, { replace: true });
      } catch (e) {
        if (!cancelled) {
          setError("This invitation link is not valid or has expired.");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [campaignPublicToken, navigate]);

  if (error) {
    return (
      <Container className="py-5 text-center">
        <p className="text-danger mb-3">{error}</p>
        <Link to={(process.env.PUBLIC_URL || "/job").replace(/\/$/, "") || "/"}>
          Go to home
        </Link>
      </Container>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <Spinner />
    </div>
  );
};

export default RecruiterCampaignInviteLanding;
